import http from '@/services/api';

const RESOURCE_NAME = 'api/reference';

/**
 * Includes a header for the middleware to attempt to retrieve cached data
 * before making an HTTP request to ECS
 * @returns {{headers: {'cache-key'}}}
 * @private
 */
function _useCacheHeader() {
  const currentAgent = JSON.parse(sessionStorage.getItem('agent'));
  return { headers: { 'cache-key': currentAgent.org } };
}

export default {
  getOrgConfiguration({ version }) {
    return http.get(`${RESOURCE_NAME}/configuration`, { params: { version } });
  },

  getAvailableTimeZones() {
    return http.get(`${RESOURCE_NAME}/timeZone/all`, _useCacheHeader());
  },

  getDefaultTimeZone() {
    return http.get(`${RESOURCE_NAME}/timeZone/default`, _useCacheHeader());
  },

  getAvailableAgentStates() {
    return http.get(`${RESOURCE_NAME}/agent/state/all`, _useCacheHeader());
  },

  getAvailableAgentCustomBreakStates() {
    return http.get(`${RESOURCE_NAME}/break/type/all`, _useCacheHeader());
  },

  getSmtpDetails() {
    return http.get(`${RESOURCE_NAME}/smtpDetails`, _useCacheHeader());
  },

  getMailSignatureFormat() {
    return http.get(`${RESOURCE_NAME}/mailSignatureFormat`, _useCacheHeader());
  },

  getMailReplyFormat() {
    return http.get(`${RESOURCE_NAME}/mailReplyFormat`, _useCacheHeader());
  },

  getCannedResponses(businessProcessId, mediaType) {
    return http.get(
      `${RESOURCE_NAME}/cannedResponse?businessProcessId=${businessProcessId}&mediaType=${mediaType}`,
      _useCacheHeader()
    );
  },

  getSupervisorKPIsDescription() {
    return http.get(`${RESOURCE_NAME}/supervisorKPIDescription/all`, _useCacheHeader());
  },

  getSmsDetails() {
    return http.get(`${RESOURCE_NAME}/smsDetails`, _useCacheHeader());
  },

  getValueSets() {
    return http.get(`${RESOURCE_NAME}/valueSets`);
  }
};
